import * as React from "react";

import "@fontsource/open-sans/latin-400.css";
import "@fontsource/open-sans/latin-600.css";
import "@fontsource/open-sans/latin-800.css";

import { PirschClientProvider } from "./src/pirsch";
import { PirschPageviewTracker } from "./src/pirsch/PirschPageviewTracker";

export const wrapRootElement = ({ element }) => {
  return <PirschClientProvider>{element}</PirschClientProvider>;
};

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      <PirschPageviewTracker location={props.location} />
      {element}
    </>
  );
};
